<div class="if-dlg">

  <!-- ── Cabecera ─────────────────────────────────────── -->
  <div class="if-dlg__head">
    <div class="if-dlg__head-left">
      <div class="if-dlg__icon"><mat-icon>class</mat-icon></div>
      <span class="if-dlg__title">Inversión</span>
      <mat-icon *ngIf="saved" class="if-dlg__saved">check_circle</mat-icon>
    </div>
    <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── Cuerpo ────────────────────────────────────────── -->
  <div class="if-dlg__body">

    <div class="if-import-banner" *ngIf="flagImport">
      Referencia: <strong>{{ movement.reference }}</strong>
    </div>

    <div class="if-layout if-layout--3" *ngIf="ready">

      <!-- Columna 1 — Identificación -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>info</mat-icon> Datos de la inversión
          </div>
          <div class="if-section__body">

            <div class="if-field" *ngIf="data == null">
              <app-autocomplete-select [items]="accounts" [(selectedItemId)]="investment.accountActivity"
                [idField]="'number'" [displayFields]="['number', 'name']" placeholder="Cuenta Inversión"
                (selectionChanged)="change(investment.accountActivity)">
              </app-autocomplete-select>
              <app-help key='Inversion1'></app-help>
            </div>
            <p *ngIf="data != null" style="font-size:13px;color:#6b7280;margin-bottom:12px">
              Cuenta: <strong>{{ investment.accountActivity }}</strong>
            </p>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción del elemento</mat-label>
              <textarea [(ngModel)]="investment.elementDescription" name="investment.elementDescription"
                matInput placeholder="Vehículo, maquinaria…" rows="2"></textarea>
            </mat-form-field>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Proveedor</mat-label>
                <input matInput [(ngModel)]="investment.provider" [matAutocomplete]="autoProvider"
                  [formControl]="contactCtrl" required />
                <mat-autocomplete #autoProvider="matAutocomplete">
                  <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                    {{ contact.companyName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="cf-spin-icon" *ngIf="(newContactLoaded | async) === false">autorenew</mat-icon>
              </mat-form-field>
              <app-help key='Inversion2'></app-help>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha de compra</mat-label>
              <input matInput [matDatepicker]="dateBuy" name="investment.dateBuy"
                [(ngModel)]="investment.dateBuy" required (dateChange)="onChangeDateBuy($event)" />
              <mat-datepicker-toggle matSuffix [for]="dateBuy"></mat-datepicker-toggle>
              <mat-datepicker #dateBuy></mat-datepicker>
            </mat-form-field>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Puesta en funcionamiento</mat-label>
                <input matInput [matDatepicker]="dateStartWorking" name="investment.dateStartWorking"
                  [(ngModel)]="investment.dateStartWorking" required />
                <mat-datepicker-toggle matSuffix [for]="dateStartWorking"></mat-datepicker-toggle>
                <mat-datepicker #dateStartWorking></mat-datepicker>
              </mat-form-field>
              <app-help key='Inversion3'></app-help>
            </div>

            <button mat-stroked-button (click)="newContact(true)" style="width:100%;border-radius:8px;margin-top:4px">
              <mat-icon>person_add</mat-icon> Nuevo contacto
            </button>
            <span *ngIf="(newContactLoaded | async) === null"
              style="font-size:12px;color:#dc2626;margin-top:4px;display:block">
              No se pudo obtener la lista de contactos
            </span>

          </div>
        </div>
      </div>

      <!-- Columna 2 — Amortización e importes -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>trending_down</mat-icon> Amortización
          </div>
          <div class="if-section__body">

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo de amortización</mat-label>
              <input matInput [(ngModel)]="investment.typeInvestment" name="investment.typeInvestment" readonly required />
            </mat-form-field>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Coeficiente lineal máximo %</mat-label>
                <input matInput [(ngModel)]="investment.maximumLinealCoeficient"
                  name="investment.maximumLinealCoeficient" required />
              </mat-form-field>
              <app-help key='Inversion4'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Periodo máximo (años)</mat-label>
                <input matInput [(ngModel)]="investment.maximumPeriod" required name="investment.maximumPeriod" />
              </mat-form-field>
              <app-help key='Inversion5'></app-help>
            </div>

          </div>
        </div>

        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>receipt</mat-icon> Importes e impuestos
          </div>
          <div class="if-section__body">

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Total (sin impuestos)</mat-label>
              <input type="text" matInput name="investment.totalWithoutTax" required
                [(ngModel)]="investment.totalWithoutTax" numberDecimalsDirective />
            </mat-form-field>

            <app-autocomplete-select [items]="accountsAndTaxes.taxes" [idField]="'id'" [displayField]="'name'"
              placeholder="Añadir impuestos" (selectionChanged)="onSelectTax($event)">
            </app-autocomplete-select>

            <convfact-chips-component [chipsElements]="investment.taxes" [container]="this" [changeFunction]="changeChips">
            </convfact-chips-component>

            <p class="if-total">Total: <span>{{ calcularTotal() }}</span></p>

          </div>
        </div>
      </div>

      <!-- Columna 3 — Documento -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>attach_file</mat-icon> Documento adjunto
          </div>
          <div class="if-section__body">
            <div class="if-file-area">
              <app-add-file [originEntity]="originEntity" [filePath]="filePath" [imageTempUrl]="imageTempUrl"
                (CallbackParameters)="SetFileParameters($event)">
              </app-add-file>
              <ng-container *ngIf="readyLoadedFiles === false">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
              </ng-container>
              <div class="if-file-preview" *ngIf="imageTempUrl != null">
                <div *ngIf="investment.image" class="imageFile">
                  <app-image-zoom [src]="imageTempUrl"></app-image-zoom>
                </div>
                <div *ngIf="investment.pdf" class="pdf-container">
                  <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                    [height]="'70%'" [textLayer]="false">
                  </ngx-extended-pdf-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Footer ────────────────────────────────────────── -->
  <div class="if-dlg__foot">
    <button mat-stroked-button class="if-btn-cancel" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="if-btn-save" (click)="save(investment)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

</div>
